"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpenAIChatModelNames = exports.aiChatRoles = exports.geminiChatRoles = exports.OpenAIChatRoles = void 0;
exports.OpenAIChatRoles = ["user", "assistant", "system"];
exports.geminiChatRoles = exports.OpenAIChatRoles;
exports.aiChatRoles = [...exports.OpenAIChatRoles, ...exports.geminiChatRoles];
const OpenAIChatModels = {
    "o1-preview": 1,
    "o1-preview-2024-09-12": 2,
    "o1-mini": 3,
    "o1-mini-2024-09-12": 4,
    "gpt-4o": 5,
    "gpt-4o-2024-08-06": 6,
    "gpt-4o-2024-05-13": 7,
    "chatgpt-4o-latest": 8,
    "gpt-4o-mini": 9,
    "gpt-4o-mini-2024-07-18": 10,
    "gpt-4-turbo": 11,
    "gpt-4-turbo-2024-04-09": 12,
    "gpt-4-0125-preview": 13,
    "gpt-4-turbo-preview": 14,
    "gpt-4-1106-preview": 15,
    "gpt-4-vision-preview": 16,
    "gpt-4": 17,
    "gpt-4-0314": 18,
    "gpt-4-0613": 19,
    "gpt-4-32k": 20,
    "gpt-4-32k-0314": 21,
    "gpt-4-32k-0613": 22,
    "gpt-3.5-turbo": 23,
    "gpt-3.5-turbo-16k": 24,
    "gpt-3.5-turbo-0301": 25,
    "gpt-3.5-turbo-0613": 26,
    "gpt-3.5-turbo-1106": 27,
    "gpt-3.5-turbo-0125": 28,
    "gpt-3.5-turbo-16k-0613": 29,
    o1: 30,
    "o1-2024-12-17": 31,
    "gpt-4o-2024-11-20": 32,
    "gpt-4o-audio-preview": 33,
    "gpt-4o-audio-preview-2024-10-01": 34,
    "gpt-4o-audio-preview-2024-12-17": 35,
    "gpt-4o-mini-audio-preview": 36,
    "gpt-4o-mini-audio-preview-2024-12-17": 37,
};
exports.OpenAIChatModelNames = Object.keys(OpenAIChatModels);
